import { useMutation } from '@tanstack/react-query';
import fileDownload from 'react-file-download';
import { downloadPdf } from './downloadPdf';
import { ErrorResponse, globalErrorResponse } from '../../shared/notification/actions';

export const useDownloadPdf = ({ id, name }: { id: string; name: string }) => {
    return useMutation(() => downloadPdf(id), {
        onSuccess: res => {
            fileDownload(res.data, `${name}.pdf`);
        },
        onError: (error: ErrorResponse) => {
            globalErrorResponse(error);
        }
    });
};
